import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { MaterialIconComponent } from '../../../material-icon/material-icon.component';

@Component({
  selector: 'shared-core-success-toast',
  imports: [MaterialIconComponent, NgOptimizedImage],
  templateUrl: './success-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessToastComponent {
  readonly message = input.required<string>();

  closeToast = output();
}
